// extracted by css-extract-rspack-plugin
export default {"lazyLoadObserver":"lazy-loading-LazyLoading-lazyLoadObserver-331a0806","lazyLoadObserverLoading":"lazy-loading-LazyLoading-lazyLoadObserverLoading-b09334b7"};